import React from 'react';

import styles from './StudentActivitySummary.scss';

const StudentActivitySummary = ({ app, students }) => {
  const filename = `icon-${app.slug}-120.png`;
  const icon = require(`./${filename}`);

  return (
    <div
      className={`StudentActivitySummary StudentActivitySummary--${app.slug}`}
    >
      <img className="StudentActivitySummary__icon" src={icon} />
      <div className="StudentActivitySummary__title">{app.title}</div>
      <div className="StudentActivitySummary__count">0</div>
      <div className="StudentActivitySummary__label">Students</div>
    </div>
  );
};

export default StudentActivitySummary;
